import { render, staticRenderFns } from "./about-banner.vue?vue&type=template&id=3b0a91be&scoped=true&"
import script from "./about-banner.vue?vue&type=script&lang=js&"
export * from "./about-banner.vue?vue&type=script&lang=js&"
import style0 from "./about-banner.vue?vue&type=style&index=0&id=3b0a91be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a91be",
  null
  
)

export default component.exports